import { useEffect, useState } from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';

import NumberFormat from 'react-number-format';

import { BERMINIMUM, MINIMALBER } from './taxes';

export const DEFAULT_SETTINGS = { minimalber: MINIMALBER, berminimum: BERMINIMUM };

// a mezőkben Ft-ban szerkesztünk, a számítás eFt-ban megy
const toFt = (eft) => String(Math.round(eft * 1000));

const FIELDS = [
  { key: 'minimalber', label: 'Minimálbér (havi)' },
  { key: 'berminimum', label: 'Garantált bérminimum (havi)' },
];

function SettingsDialog({ open, settings, onClose, onSave }) {
  const [draft, setDraft] = useState({});

  useEffect(() => {
    if (open) {
      setDraft({
        minimalber: toFt(settings.minimalber),
        berminimum: toFt(settings.berminimum),
      });
    }
  }, [open, settings]);

  const valid = FIELDS.every(({ key }) => Number(draft[key]) > 0);

  return (
    <Dialog open={open} onClose={onClose} maxWidth='xs' fullWidth>
      <DialogTitle>Beállítások</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ marginBottom: 2 }}>
          Alapértelmezetten a 2026-os értékekkel számolunk. Ha már ismered a
          2027-es összegeket, itt átírhatod őket. A minimálbértől függ az
          átalányadó adómentes része és bevételi korlátja, valamint a SZOCHO
          felső határa is.
        </DialogContentText>
        {FIELDS.map(({ key, label }) => (
          <NumberFormat
            key={key}
            customInput={TextField}
            label={label}
            value={draft[key] ?? ''}
            onValueChange={({ value }) =>
              setDraft((d) => ({ ...d, [key]: value }))
            }
            thousandSeparator=' '
            decimalScale={0}
            allowNegative={false}
            isAllowed={({ value }) => value.length <= 7}
            isNumericString
            inputMode='numeric'
            fullWidth
            margin='dense'
            InputProps={{
              endAdornment: <InputAdornment position='end'>Ft</InputAdornment>,
            }}
          />
        ))}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() =>
            setDraft({
              minimalber: toFt(DEFAULT_SETTINGS.minimalber),
              berminimum: toFt(DEFAULT_SETTINGS.berminimum),
            })
          }
          sx={{ marginRight: 'auto' }}
        >
          Alapértékek
        </Button>
        <Button onClick={onClose}>Mégse</Button>
        <Button
          variant='contained'
          disabled={!valid}
          onClick={() =>
            onSave({
              minimalber: Number(draft.minimalber) / 1000,
              berminimum: Number(draft.berminimum) / 1000,
            })
          }
        >
          Mentés
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SettingsDialog;
